export const BASE_THEME = {
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '2px'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          ':last-child': {
            paddingBottom: '16px'
          }
        }
      }
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 25,
        }
      }
    }
  },
  typography: {
    fontFamily: [
      'Noto Sans JP'
    ],
    h1: {
      fontSize: '3.75rem',
      fontWeight: 'bold'
    },
    h2: {
      fontSize: '2.75rem',
      fontWeight: 'bold'
    },
    h3: {
      fontSize: '2.25rem',
      fontWeight: 'bold'
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 'bold'
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 'bold'
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 'bold'
    }
  },
};